export interface IEquityMovementScheduleTableEntryFlis {
    [fliName: string]: number | null;
}
